import React, { Component } from 'react';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { Provider, connect } from 'react-redux';
import saga from '../../sagas/followup_questions/new';
import Module from '../../modules/followup_questions/new';
import Options from '../../components/questions/options';
import ModalAlert from '../../components/modal/modal_alert';

const sagaMiddleware = createSagaMiddleware();
const store = createStore(Module.reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(saga);

export default class FollowupQuestionsNew extends Component {
  render() {
    return (
      <Provider store={store}>
        <Root
          questions={this.props.questions}
          rurl={this.props.rurl}
          eventId={this.props.eventId}
        />
      </Provider>
    );
  }
}

class TmpRoot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFirstPageValid: false,
      isSubmitting: false,
    };
    this.onClickNextPageBtn = this.onClickNextPageBtn.bind(this);
    this.onClickPrevPageBtn = this.onClickPrevPageBtn.bind(this);
    this.onClickRegisterBtn = this.onClickRegisterBtn.bind(this);
    this.toSearchEvents = this.toSearchEvents.bind(this);
    this.changeFields = this.changeFields.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.modalIsOpen) {
      switch (nextProps.submitStatus) {
        case 'success':
          this.modalAlertSuccess.openModal();
          break;
        case 'error':
          this.setState({ isSubmitting: false });
          this.modalAlertError.openModal();
          break;
      }
    }
  }

  /**
   * 表示ページが変更された時の処理
   * @param {*} e
   */
  onClickNextPageBtn(e) {
    e.preventDefault();
    this.props.changePage(this.props.pageIndex + 1);
  }

  /**
   * 表示ページが変更された時の処理
   * @param {*} e
   */
  onClickPrevPageBtn(e) {
    e.preventDefault();
    this.props.changePage(this.props.pageIndex - 1);
  }

  /**
   * 登録するボタンが押されたときの処理
   * @param {*} e
   */
  onClickRegisterBtn() {
    this.setState({ isSubmitting: true });
    const answers = this.props.answers;
    const eventId = this.props.eventId;
    this.props.registerAnswers(answers, eventId);
  }

  toSearchEvents() {
    location.href = '/search';
  }

  changeFields(question_id, option_answer, text_answer) {
    let answers = this.props.answers;

    let updatedAnswers = answers.filter(function (item) {
      return item.question_id !== question_id;
    });
    updatedAnswers.push({
      question_id: question_id,
      option_answer: option_answer,
      text_answer: text_answer,
    });
    this.props.changeFields(updatedAnswers);
    // this.setState({}); // これがないとつぎへボタンの表示制御ができない
  }

  render() {
    const questions = this.props.questions;
    let pageIndex = this.props.pageIndex ? this.props.pageIndex : 1;
    const question = questions[pageIndex - 1] ? questions[pageIndex - 1] : {};
    const answer = this.props.answers.filter(function (item) {
      return item.question_id === question.id;
    })[0];

    let prevPageBtn = '';
    if (pageIndex !== 1) {
      prevPageBtn = (
        <button
          type="button"
          className="col-5 a-button a-button__top a-button__top--outline w-100 mb-2"
          onClick={this.onClickPrevPageBtn}
        >
          戻る
        </button>
      );
    }
    let nextPageBtn = '';
    if (pageIndex !== this.props.questions.length) {
      nextPageBtn = (
        <button
          type="button"
          className="col-5 a-button a-button__top a-button--orange w-100 mb-2"
          onClick={this.onClickNextPageBtn}
          disabled={
            (typeof answer !== 'undefined' &&
              typeof answer.option_answer !== 'undefined' &&
              answer.option_answer.length !== 0) ||
            (typeof answer !== 'undefined' &&
              typeof answer.text_answer !== 'undefined' &&
              answer.text_answer !== '') ||
            !question.is_required
              ? false
              : true
          }
        >
          次へ
        </button>
      );
    }

    let registerBtn = '';
    if (pageIndex === this.props.questions.length) {
      registerBtn = (
        <button
          type="button"
          className="col-5 a-button a-button__top a-button--orange w-100 mb-2"
          onClick={this.onClickRegisterBtn}
          disabled={this.state.isSubmitting}
        >
          回答する
        </button>
      );
    }
    const questionsBox = (
      <div
        className="pt-2"
        style={{
          marginTop: '30px',
          marginBottom: '50px',
          borderRadius: '0.25rem',
        }}
      >
        {pageIndex == 1 ? (
          <p className="text-fz-14px text-center mb-3_5 line-height-2">
            アンケートの標準回答時間は2分です。
          </p>
        ) : (
          ''
        )}
        <h6 className="text-fw-bold text-center mb-3_5 line-height-2">
          （ {pageIndex} / {questions.length} ）<br />
          {question.wording}
          {question.choice_type == 2 || question.choice_type == 5
            ? ' （複数選択可）'
            : ''}
        </h6>
        <Options
          question={question}
          pageIndex={pageIndex}
          changeFields={this.changeFields}
          answer={answer}
        />
      </div>
    );

    const page = (
      <div className="container col-md-8 col-lg-6">
        {questionsBox}
        <div className="container col-md-8 col-lg-6">
          <div className="d-flex justify-content-around align-items-center">
            {prevPageBtn}
            {nextPageBtn}
            {registerBtn}
          </div>
        </div>
      </div>
    );

    return (
      <div>
        {page}
        <ModalAlert
          ref={(c) => {
            this.modalAlertSuccess = c;
          }}
          id="modalAlertSuccess"
          title="アンケートをご回答頂きありがとうございました"
          content="次回のイベントもぜひご参加お願い致します。"
          approveFunc={this.toSearchEvents}
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertError = c;
          }}
          id="modalAlertError"
          title="アンケート登録エラー"
          content="アンケート登録に失敗しました。時間をおいてもう一度お試しください。"
        />
      </div>
    );
  }
}

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, ownProps) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => {
  return {
    changePage: (pageIndex) => {
      dispatch(Module.actions.changePage({ pageIndex }));
    },
    changeFields: (answers) => {
      dispatch(Module.actions.changeFields({ answers }));
    },
    registerAnswers: (answers, eventId) => {
      dispatch(Module.actions.registerAnswers({ answers, eventId }));
    },
  };
};

const Root = connect(mapStateToProps, mapDispatchToProps)(TmpRoot);
